// Copyright (c) 2025 Just Feasible Solutions LLC. All rights reserved.
// This file is part of the Just Feasible Solutions application.
// Unauthorized copying, distribution, or modification of this file is prohibited.
// For license information, contact the author.

import React from 'react';

const PrivacyChoices = () => (
  <div style={{ maxWidth: 900, margin: '0 auto', padding: '2rem' }}>
    <h1>Privacy Choices</h1>
    <p>
      At Just Feasible Solutions LLC, we respect your privacy and give you control over your personal information. Here are your privacy choices regarding how your data is collected, used, and shared:
    </p>
    <ul>
      <li><b>Access & Correction:</b> You may request access to or correction of your personal information at any time by contacting us.</li>
      <li><b>Marketing Communications:</b> You can opt out of receiving marketing emails by using the unsubscribe link in our emails or by contacting us directly.</li>
      <li><b>Cookie Preferences:</b> You can manage your cookie settings on our <button type="button" onClick={() => { window.location.hash = ''; window.scrollTo(0,0); }} style={{ background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer', textDecoration: 'underline', font: 'inherit' }}>Cookies Settings</button> page or through your browser settings.</li>
      <li><b>Account Deletion:</b> You may request deletion of your account and associated data by contacting our support team.</li>
      <li><b>Data Portability:</b> You may request a copy of your data in a portable format.</li>
      <li><b>Third-Party Sharing:</b> You can opt out of certain data sharing with third parties for marketing or analytics purposes.</li>
    </ul>
    <p>
      To exercise any of these rights or for more information, please contact us at <a href="mailto:support@justfeasible.com">support@justfeasible.com</a>.
    </p>
    <p style={{ marginTop: 32, color: '#888', fontSize: '0.97rem' }}>
      &copy; 2025 Just Feasible Solutions LLC. All rights reserved.
    </p>
  </div>
);

export default PrivacyChoices;
